<template>
  <div>
    <p>欢迎您使用小马哥未来商圈商户服务（以下简称“服务”）。提示：在您使用小马哥未来商圈支付服务之前，您应当
      认真阅读并遵守《小马哥未来商圈商户注册及服务协议》（以下简称“本协议”）。
    </p>
    <p>本协议是由您在杭州有云科技有限公司（经营地址：浙江省杭州市西湖区浙大森林A座）开发并运营的小马哥商户端
      （包括网页版商户后台、老板来app等各种软件及应用程序，以下简称：“小马哥”）上签署。
    </p>
    <p>本协议对杭州有云科技有限公司和您具有合同上的法律效力，在您使用小马哥未来商圈服务前，请您务必审慎阅读，
      充分理解各条款内容，特别是其中加粗带▲标记的条款。请您审慎阅读并选择接受或不接受本协议，您一经勾选或者
      使用小马哥未来商圈服务即视为对本协议全部条款已充分理解并完全接受
    </p>
    <h4>一、协议内容及确认</h4>
    <p>1.1 本协议内容包括本协议正文及所有小马哥已经发布或将来可能发布及修改的各项服务条款，政策、规则、
      声明、通知、警示、提示、说明等（以下简称“规则”）。前述规则为本协议不可分割的组成部分，与协议正文具有
      同等法律效力。
    </p>
    <p>1.2 当您按照注册页面提示填写信息、上传资质信息等完成全部注册流程后，即表示您已充分阅读、理解并接受
      本协议的全部内容，本协议即产生法律效力。
    </p>
    <p>1.3 小马哥未来商圈（可能包括与合作第三方一起）向您提供的服务，当您在相关页面上点击确认的时候，
      例如，您点击“开通服务”或类似文字的按钮，或者您已经实际使用该服务时，您点击确认或实际使用服务即代表
      您接受协议的全部内容。
    </p>
    <p>1.4 根据国家法律法规变化及网站运营需要，小马哥未来商圈有权根据需要不时制订、修改本协议及相关规则，
      变更后的协议和规则一经公布，立即取代原协议及规则并自动生效。您可以在小马哥未来商圈随时查阅最新协议。
      如您不同意相关变更，应当于协议修改或更新公示后七日内提出意见，如您继续使用服务或在小马哥未来商圈系统
      内进行任何操作活动，即表示您已接受经修订的协议和规则。对于您提出的反馈意见，杭州有云科技有限公司可
      予以考虑但最终仍由我司全权决定是否进行调整或更新；如您对最终变更后的协议仍不同意接受的，应提前三日
      通知杭州有云科技有限公司终止本协议、停止使用相关服务，并处理结清所有未决事宜。
    </p>
    <p>1.5 如果您在任何时候对任何内容存在疑虑或异议，请您立即联系杭州有云科技有限公司
      （联系电话400-081-8661），以便对相关内容进行解释和说明，使您能够充分理解，从而帮助您决定是否接受
      服务规则及使用的服务。
    </p>
    <h4>二、服务内容</h4>
    <p>2.1 小马哥未来商圈提供包括但不限于手机客户端（IOS及Android版本）（具体以小马哥最终提供的为准），
      电脑软件，小马哥未来商圈收款硬件等产品形态。如您已注册使用一种产品形式的服务，则可以以同一账号使用其他
      版本服务，本协议自动适用于您对所有版本的软件和服务的使用。
    </p>
    <p>2.2 本服务内容范围包括但不限于门店移动支付技术服务、门店营销服务、供应链服务等一系列技术服务范畴。
      这些功能服务会根据您需求的变化，服务范围的扩展，服务提供方（合作伙伴）的要求或行业规定变化而被优化或修改，
      或因定期、不定期的维护而暂缓提供。
    </p>
    <p>2.3 同时，小马哥未来商圈有权自行决定对服务或服务任何部分及其相关功能、应用软件变更、升级、修改、转移的
      权利。您同意针对上述行为，小马哥未来商圈发出通知后将自动进行功能或软件的变更、升级、修改、转移。
    </p>
    <p>2.4 本协议项下的各项服务（包括未来将推出的服务）将由杭州有云科技有限公司及其关联公司自行或根据第三方
      合作方的授权分别或共同提供，或由第三方合作方提供。
    </p>
    <h4>三、服务使用规范</h4>
    <p>3.1 您承诺，使用小马哥未来商圈服务时，您将严格遵守本协议所列明的各项规则及规范要求。</p>
    <p>▲3.2 您充分了解并同意，小马哥未来商圈仅为您提供服务，您应自行对利用服务从事的所有行为及结果承担责任。
      相应地，您应了解，使用服务可能发生来自他人非法或不当行为（或信息）的风险，您应自行判断及行动，并自行
      承担相应的风险。
    </p>
    <p>3.3 您承诺不会利用本服务进行任何违法或不当的活动，包括但不限于下列行为:</p>
    <p>3.3.1 上载、传送或分享含有下列内容之一的信息：</p>
    <p>(a) 反对法律规定；</p>
    <p>(b) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
    <p>(c) 损害国家荣誉和利益的；</p>
    <p>(d) 煽动民族仇恨、民族歧视、破坏民族团结的；</p>
    <p>(e) 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
    <p>(f) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
    <p>(g) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
    <p>(h) 侮辱或者诽谤他人，侵害他人合法权利的；</p>
    <p>(i) 含有虚假、诈骗、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其它道德上令人反感的内容；</p>
    <p>(j) 含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的；</p>
    <p>3.3.2 冒充任何人或机构，或以虚伪不实的方式陈述或谎称与任何人或机构有关；</p>
    <p>3.3.3 伪造标题或以其他方式操控识别资料，使人误认为该内容为小马哥或其关联公司所传送；</p>
    <p>3.3.4 将依据任何法律或合约或法定关系（例如由于雇佣关系和依据保密合约所得知或揭露之内部资料、专属及机密
      资料）知悉但无权传送之任何内容加以上载、传送或分享；
    </p>
    <p>3.3.5 将涉嫌侵害他人权利（包括但不限于著作权、专利权、商标权、商业秘密等知识产权）之内容上载、传送或分享；</p>
    <p>3.3.6 跟踪或以其它方式骚扰他人,或通过本服务向好友或其他用户发送大量信息；进行任何超出正常的好友或用户
      之间内部或外部信息沟通、交流等目的的行为；
    </p>
    <p>3.3.7 将任何广告、推广信息、促销资料、垃圾邮件、滥发信件、连锁信件、直销或其它任何形式的劝诱资料加以上载、
      传送或分享；供前述目的使用的专用区域或专用功能除外；
    </p>
    <p>3.3.8 从事任何违反中国法律、法规、规章、政策、规范性文件以及支付机构规定的行为，例如信用卡及第三方机构
      提供的信用额度套现交易、他人支付账号的盗刷交易、为获得支付机构的补贴而进行的无正常交易实质的交易等。
    </p>
    <h5>3.4 您承诺不对本软件和服务从事以下行为：</h5>
    <p>3.4.1 将有关干扰、破坏或限制任何计算机软件、硬件或通讯设备功能的软件病毒或其他计算机代码、档案和程序之
      资料，加以上载、张贴、发送电子邮件或以其他方式传送；
    </p>
    <p>3.4.2 干扰或破坏本服务或与本服务相连线之服务器和网络，或违反任何关于本服务连线网络之规定、程序、政策或
      规范；
    </p>
    <p>3.4.3 通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的
      软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
    </p>
    <p>3.4.4 自行、授权他人或利用第三方软件对本软件及其组件、模块、数据等进行干扰，反向工程。</p>
    <p>3.4.5 您应自行承担因使用服务所产生的费用，包括但不限于上网流量费、通信服务费等。</p>
    <p>3.4.6 您承诺您所上载、传送或分享的资料及信息系真实且合法有效，如您所提供的资料及信息存在真实性及合法性
      问题，我司有权拒绝提供服务并解除本协议。同时，我司有权对您上载，传送或则会分享的资料信息，以及使用服务
      的情况进行合规性审查、监督，如您存在违反本协议第四条第3款规定使用本服务，我司有权采取相应行动，包括
      但不限于删除信息、中止或终止服务，及向有关机关报告。您应自行承担因前述违法违规行为而受到的损失，
      如沃斯因此受到政府部门的处罚，您应一并进行赔偿。
    </p>
    <p>3.4.7 您承诺不以任何形式使用本服务侵犯我司的商业利益，或从事任何可能对我司造成损害或不利于小马哥的行为</p>
    <p>3.4.8 您可以在小马哥上根据实际需求添加门店、终端、管理员、收银员，但您对上述添加行为以及之后的操作行为
      承担责任，如果由于您添加上述账号从而导致损失，由您自行承担或赔偿。
    </p>
    <p>3.4.9 您充分了解并同意，您必须为自己注册帐号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何
      后果。您应对使用本服务时接触到的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、
      完整性或实用性的依赖而产生的风险。我司无法且不会对您因前述风险而导致的任何损失或损害承担责任。
    </p>
    <p>3.4.10 如果我司发现或收到他人举报您有违反本协议约定的，我司有权不经通知随时对相关内容进行删除、屏蔽，
      并采取包括但不限于收回账号，冻结账户资金，限制、暂停、终止您使用部分或全部本服务，追究法律责任等措施，
      由此产生的损失将由您自行承担。
    </p>
    <p>3.4.11 如您使用小马哥未来商圈发布的信息内容违法违规，我司有权视情采取警示、限制功能、暂停更新、关闭账号
      等处置措施，保存记录并向有关主管部门报告，由此产生的损失将由您自行承担。
    </p>
    <h4>四、服务费用</h4>
    <p>4.1 商户注册成功后，我司将收取商户因使用相关服务而发生的服务费。因服务的任何免费试用或免费功能和服务
      不应视为我司放弃后续收费的权利。我司有权以书面形式通知您收费标准，若您继续使用则表述您接受小马哥的服务，
      需按我司公布的收费标准支付费用。
    </p>
    <p>4.2 不同服务的费用以各服务的具体条款确定，包括具体支付方式等。</p>
    <p>▲4.3 我司有权根据实际情况提前单方面调整服务费用标准及收费方式，并以公告形式通知您，而无需获得您的事先
      同意，如您不同意收费应当立即停止服务的使用，否则使用则视为您已同意并应当缴纳费用。
    </p>
    <h4>五、门店移动支付服务</h4>
    <p>5.1 您使用小马哥未来商圈表明您向杭州有云科技有限公司申请通过小马哥未来商圈接入并使用以下服务
      （合称“支付服务”）
    </p>
    <p>微信支付</p>
    <p>支付宝支付</p>
    <p>云闪付</p>
    <p>其他</p>
    <p>▲5.2 根据您的申请，我司将根据支付服务所对应的支付合作方的要求对您的资质进行审查，是否开通上述支付解决
      服务以及开通哪些
    </p>
    <p>5.3 您无论使用以上任一或全部服务，均应遵守本协议项下的各项约定，以及所有适用法律法规和监管部门、结算
      机构、支付合作方的规定和要求。
    </p>
    <h5>5.4 使用限制</h5>
    <p>您了解并同意，我司及支付合作方可以根据业务场景需求及自身业务需要，制定相关限制条款，包括但不限于消费者
      一次性/累计支付上限，您一次性/累计收款金额上限等。具体以我司及支付合作方公式的结果为准。
    </p>
    <h5>5.5 服务费用</h5>
    <p>▲您开通上述支付服务需要支付的每笔交易手续费及其他费用以您我司账户内显示的交易费率提示为准。如果您使用
      小马哥的服务，表明您同意接受上述交易手续费及其他费用。
    </p>
    <h4>六、特别授权</h4>
    <p>一旦您违反本协议，或与杭州有云科技有限公司及我司（共同合作为您提供服务）签订的其他协议的约定，我司有权
      以任何方式通知合作伙伴，要求其对您的权益采取限制措施，包括但不限于要求我司合作伙伴中止、终止对您提供部分
      或全部服务，且在其经营或实际控制的任何网站公示您的违约情况，由此产生的损失应由您自行承担。我司有权根据
      您上述违约行为的影响等来决定部分或全部服务恢复的时间。
    </p>
    <h4>七、第三方应用</h4>
    <p>▲7.1 我司允许第三方应用接入服务，您可以在小马哥未来商圈直接获得各种第三方应用服务。您了解并同意，相关
      应用以及服务由该第三方独立提供，我司不对您对该应用的使用承担任何责任。
    </p>
    <p>7.2 您了解并同意，如我司对服务或其部分做出调整、中止或终止而对第三方应用服务产生影响，小马哥不承担任何责任。</p>
    <p>7.3 您通过第三方应用或服务使用时，小马哥可能会调用第三方系统或者通过第三方支持您的使用或访问，使用或访问
      的结果由该第三方提供。
    </p>
    <p>7.4 第三方应用也可以通过调用小马哥提供的接口获得您在小马哥的信息，但必须得到您的授权同意。</p>
    <h4>八、服务中止或终止</h4>
    <p>8.1 您同意，鉴于互联网服务的特殊性，小马哥有权随时中止、终止或致使中止终止服务或其任何部分；对于免费
      服务发生中止或终止的情形，小马哥无需向您发出通知。
    </p>
    <p>8.2 您了解并同意，小马哥可能定期或不定期地对提供网络服务的设备、设施和软硬件进行维护或检修，如因此类
      情况而造成收费服务在合理时间内中止，小马哥无需承担责任，但应尽可能事先进行通告。
    </p>
    <p>8.3 如存在下列违约情形之一，小马哥可立即中止或终止服务，并要求您赔偿损失：</p>
    <p>8.3.1 您违反本协议约定的注册义务和使用规范；</p>
    <p>8.3.2 您使用收费服务时未按规定支付相应服务费；</p>
    <h4>九、隐私政策</h4>
    <p>9.1 您在服务注册的账户具有密码保护功能，以确保您基本信息资料的安全，请您妥善保管账户及密码信息。</p>
    <p>9.2 小马哥勤勉尽职地采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您存储在中的信息
      和通信内容不会被泄漏、毁损或者丢失。小马哥会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全
      保障，小马哥将在任何时候尽力做到使您的信息不被泄漏、毁损或丢失，但同时也请您注意在信息网络上不存在绝对
      完善的安全措施，请妥善保管好相关信息。
    </p>
    <p>9.3 小马哥有权根据法律规定和业务情况决定您在本软件及服务中数据的最长储存期限、服务器中数据的最大
      存储空间等，您应当保管好终端、账号及密码，并妥善保管相关信息和内容，小马哥对您自身原因导致的数据丢失
      或被盗以及在本软件及服务中相关数据的删除或储存失败不承担责任。
    </p>
    <p>9.4 小马哥将依法保障您在使用本服务过程中的知情权和选择权，如为提供服务之目的而需要开启收集地理位置、
      读取通讯录、使用摄像头、启用录音等功能，将向您明示并取得您的同意。
    </p>
    <p>9.5 其他隐私条款见《老板来App用户隐私政策》。</p>
    <h4>十、知识产权</h4>
    <p>10.1 您了解及同意，除非小马哥另行声明，本协议项下服务包含的所有产品、技术、软件、程序、数据及其他信息
      （包括但不限于文字、图像、图片、照片、音频、视频、图表、色彩、版面设计、电子文档）的所有知识产权
      （包括但不限于版权、商标权、专利权、商业秘密等）及相关权利均归小马哥或其关联公司所有。
    </p>
    <p>10.2 您应保证，除非取得小马哥书面授权，对于上述权利您不得（并不得允许任何第三人）实施包括但不限于出租、
      出借、出售、散布、复制、修改、转载、汇编、发表、出版、还原工程、反向汇编、反向编译，或以其它方式发现原始
      码等的行为。
    </p>
    <p>10.3 服务涉及的Logo（包括但不限于“小马哥”）等文字、图形及其组成，以及小马哥其他标识、产品和服务名称
      均为小马哥商标，您未经小马哥书面授权不得以任何方式展示、使用或作其他处理，也不得向他人表明您有权展示、
      使用、或作其他处理。
    </p>
    <p>10.4 您理解并同意授权小马哥在宣传和推广中使用您的名称、商标、标识，但仅限于表明您属于我们的客户或合作
      伙伴。
    </p>
    <h4>十一、责任承担</h4>
    <p>11.1 服务将按"现状"和按"可得到"的状态提供。小马哥在此明确声明对服务不作任何明示或暗示的保证，包括但
      不限于对服务的可适用性，没有错误或疏漏，持续性，准确性，可靠性，适用于某一特定用途之类的保证，声明
      或承诺。
    </p>
    <p>11.2 小马哥对服务所涉的技术和信息的有效性，准确性，正确性，可靠性，质量，稳定，完整和及时性均不作
      承诺和保证。
    </p>
    <p>11.3 小马哥系统在下列状况发生时会无法正常运作，所以下列情形中小马哥无法向您提供服务。您对此充分理解并
      同意小马哥无须就下述情况所导致服务无法正常提供时给您造成的各种影响或损失承担责任：
    </p>
    <p>11.3.1 我们公告的系统停机维护期间。</p>
    <p>11.3.2 电信设备出现故障不能进行数据传输的。</p>
    <p>11.3.3 发生台风、地震、海啸、洪水、停电、战争、恐怖袭击等事件造成我们系统障碍不能执行业务的。</p>
    <p>11.3.4 由于黑客攻击、电信部门技术调整或故障、网站升级、第三方方面的问题等原因而造成我们的服务中断或者延迟。</p>
    <p>11.4 不论是否可以预见，不论是源于何种形式的行为，小马哥不对由以下原因造成的任何特别的，直接的，间接的，
      惩罚性的，突发性的或有因果关系的损害或其他任何损害（包括但不限于利润或利息的损失，营业中止，资料灭失）
      承担责任。
    </p>
    <p>11.4.1 使用或不能使用服务；</p>
    <p>11.4.2 通过服务购买或获取任何产品，样品，数据，信息或进行交易等，或其他可替代上述行为的行为而产生的费用；</p>
    <p>11.4.3 未经授权的存取或修改数据或数据的传输；</p>
    <p>11.4.4 第三方通过服务所作的陈述或行为；</p>
    <p>11.4.5 其它与服务相关事件，包括疏忽等，所造成的损害。</p>
    <p>11.5 您充分了解并同意，鉴于互联网体制及环境的特殊性，您在服务中分享的信息及个人资料有可能会被他人复制、
      转载、擅改或做其它非法用途；您在此已充分意识此类风险的存在，并确认此等风险应完全由您自行承担，小马哥对此
      不承担任何责任。
    </p>
    <p>11.6 您了解并同意，在使用服务过程中可能存在来自任何他人的包括威胁性的、诽谤性的、令人反感的或非法的内容或
      行为或对他人权利的侵犯（包括知识产权）及匿名或冒名的信息的风险，基于服务使用规范所述，该等风险应由您
      自行承担，小马哥对此不承担任何责任。
    </p>
    <h4>十二、个人信息授权</h4>
    <p>▲11.1、您同意授权小马哥，基于信息备份、运营需要或经有权部门要求等目的，有权通过您以及您曾经或正在
      使用的第三方收银服务机构以及其他第三方数据机构等对您的个人基本信息、财务信息，服务信息等数据或信息进行
      核实，有权通过您或前述第三方收银机构采集您的个人基本信息、财务信息、交易信息等信息，您同意授权小马哥
      通过第三方收银服务机构采集相关信息。
    </p>
    <p>▲12.2、您同意授权小马哥向第三方服务机构提供您的个人基本信息、财务信息，服务信息等以判断、识别业务风险
      及提升自身服务质量；且您同意第三方服务机构依据法律法规就授权范围内对上述信息进行采集、获取、存储、处理、
      提供、传输、披露。您同意授权小马哥有权从第三方收银服务机构采集商户的个人基本信息，财务信息，交易信息
      等信息。
    </p>
    <h4>十三、违约责任及赔偿</h4>
    <p>13.1 如果小马哥发现或收到他人举报您有违反本协议约定的，经核实后小马哥有权不经通知随时对相关内容进行
      删除、屏蔽，并采取包括但不限于限制、暂停、终止您使用账号及服务，限制、暂停、终止您使用部分或全部本服务，
      追究法律责任等措施。
    </p>
    <p>13.2 您同意，由于您通过服务上载、传送或分享之信息、使用本服务其他功能、违反本协议、或您侵害他人任何权利因
      而衍生或导致任何第三人向小马哥及其合作伙伴提出任何索赔或请求，或小马哥及其合作伙伴因此而发生任何损失，
      您同意将足额进行赔偿（包括但不限于合理律师费）。
    </p>
    <h4>十四、有效通知</h4>
    <p>14.1 小马哥向您发出的任何通知，可采用电子邮件、页面公开区域公告、个人网络区域提示、手机短信或常规信件
      等方式，且该等通知应自发送之日视为已向您送达或生效。
    </p>
    <p>14.2 您同意，您向小马哥发出的任何通知应发至小马哥对外正式公布告知您的电子邮件、通信地址、传真号码
      等联系信息，或使用其他小马哥认可的其他通知方式进行送达。
    </p>
    <h4>十五、争议解决及其他</h4>
    <p>15.1 本协议之解释与适用，以及与本协议有关的争议，均应依照中华人民共和国法律予以处理。双方因本协议发生
      纠纷，应本着友好协商的原则商议解决，若协商不成，任何一方均有权提交上海市普陀区法院诉讼管辖。除非另有规定，
      诉讼期间双方应当继续履行协议规定的义务。
    </p>
    <p>15.2 如本协议的任何条款被视作无效或无法执行，其余部分则仍具有法律效力。</p>
    <p>15.3 小马哥针对您过失或违约时放弃本协议规定的权利的，不得视为其对您的其他或以后同类之过失或违约行为弃权。</p>
    <p>15.4 本协议取代双方此前就本协议任何事项达成的全部口头和书面协议、安排、谅解和通信。</p>
    <p>15.5 小马哥有权根据业务调整情况将本协议项下的全部权利义务一并转移给其合作伙伴，转让将以本协议规定的
      方式通知，您承诺对此不持有异议。
    </p>
  </div>
</template>

<script>
  export default {
    name: 'BossComeProtocol',
    data () {
      return {
     
      }
    }
  }
</script>

<style>
  p {
    text-align: left;
  }
  h4 {
    text-align: left;
  }
  h5 {
    text-align: left;
  }
</style>


// WEBPACK FOOTER //
// src/components/BossComeProtocol.vue